import jquery from 'jquery';
window.$ = jquery;

$( document ).on('turbolinks:load', function() {
  window.addEventListener("keydown",function (e) {
    if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
      if(!$('#dropdown-menu-search').hasClass("open")) {
        $('#ddSearch').dropdown('toggle');
      }
      setTimeout('$("#search").focus();$("#search").select()', 100);
      e.preventDefault();
    }
  });

  $('input#search').keyup(function(e) {
    if (e.keyCode === 27) {
      $('#ddSearch').dropdown('toggle');
    }
  });

  $(document).on("ajax:send", function(xhr) {
    cowork.loadingFadeIn()
  });

  $(document).on("ajax:complete", function(xhr, status) {
    cowork.loadingFadeOut()
  });

  $('#ddSearch').on('click', function(e) {
    setTimeout('$("#search").focus();$("#search").select()', 100);
  });

  $('#sidebarCollapse').on('click', function () {
    toggleSidebar();
  });

  $('#overlay').on('click', function () {
    toggleSidebar();
  });

  $('#sidebarDropdownMenu > a').on('click', function () {
    if($('#sidebar').hasClass('active')) {
      toggleSidebar();
    }
  });

  $('div.dropdown-menu a[data-remote=true]').click(function () {
    $(this).closest('div').prev('button').dropdown('toggle');
    $(this).closest('div').prev('a').dropdown('toggle');
  });

  cowork.loadingFadeOut()
});

export function loadingFadeIn() {
  let loading = document.querySelector("div#loading");
  loading.style.opacity = 1;
}
export function loadingFadeOut() {
  let loading = document.querySelector("div#loading");
  loading.style.opacity = 0;
}

export function showAlert(type, message, reload = false, delay = 15000) {
  var content = document.querySelector("#content");
  var alert = document.createElement("div");

  alert.classList.add("alert", `alert-${type}`, "alert-dismissible", "fade", "show");
  alert.setAttribute("role", "alert");
  alert.innerHTML = `
    <i class='fa fa-info-circle fa-lg'></i> ${message}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  `;
  content.prepend(alert);

  if(reload) {
    delay = 3000;
  }
  setTimeout(() => {
    var a = bootstrap.Alert.getOrCreateInstance(alert);
    if(a) {
      a.close();
      if(reload) {
        location.reload();
      }
    }
  }, delay);
}

export function uploadFiles(files, project, folder) {
  for (var i = 0; i < files.length; i++) {
    let token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
    let fd = new FormData();
    fd.append('dfile[label]', files[i].name);
    fd.append('dfile[description]', '');
    fd.append('dfile[phash]', project);
    fd.append('dfile[state]', 'final');
    fd.append('dfile[folder]', folder);
    fd.append('file', files[i]);

    $.ajax({
      type: "POST",
      url: '/files/upload',
      headers: {
        'X-CSRF-Token':token,
      },
      data: fd,
      processData: false,
      contentType: false
    })
    .done(function() {
      $("#info").fadeTo(8000, 500).slideUp(500);
    })
    .fail(function(event) {
      console.log( event );
    });
  }
}

export function registerCheckData() {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  $('#loading').fadeIn();
	$('#btnSubmit').prop('disabled', true);
  $('#btnSubmit').removeClass('btn-success').addClass('btn-warning');

  var form = document.getElementById("register");
  if (form.checkValidity() === false || !$("#user_tos").is(":checked")) {
    form.classList.add('was-validated');
    $('#user_firstname').focus();
    $('#btnSubmit').prop('disabled', false);
    $('#btnSubmit').removeClass('btn-warning').addClass('btn-success');
    $('#loading').fadeOut();
    return false;
  } else {
    Rails.fire(form, 'submit');
  }
}

export function toggleSidebar() {
  $('#sidebar').toggleClass('active');
  $('#overlay').toggleClass('active');
}


/*
  WebPush Functions
*/

//var vapidPublicKey = new Uint8Array("BKysGPM94-7vQP8kmXXrwrt2p2RfXHRxAosqgxW5nq-G16P7KdgHWjoRC9QS5s_UeSKaP0q9-R-aCA7PfYT69Ls=");
var vapidPublicKey = "BPwcviZacMF0aL2nrprbWjYqQtoaikpvTynK5ZZrfzb-tN70FGYGd4e4y6-eekHkDr_K1ngNPIOZgTdLQqIE6BM";

export function checkNotificationPermissions(obj){
  if (!("Notification" in window)) {
    console.error("This browser does not support desktop notification");
  }
  else if (Notification.permission === "granted")
  {
    console.log("Permission to receive notifications has been granted");
    getNotificationKeys();
  }
  else if (Notification.permission !== 'denied')
  {
    Notification.requestPermission(function (permission) {
      if (permission === "granted") {
        console.log("Permission to receive notifications has been granted");
        getNotificationKeys();
      }
    });
  }
}

export function getNotificationKeys(){
  navigator.serviceWorker.register('/serviceworker.js', {scope: '/'})
    .then(function(registration) {
      return registration.pushManager.getSubscription()
      .then(function(subscription) {
        if (subscription) {
          return subscription;
        }
        return registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: vapidPublicKey
        });
    });
  })
  .then(function(subscription) {
    cowork.sendNotificationKeys(subscription.toJSON())
  });
}

export function sendNotificationKeys(subscription){
  $.ajax({
    url: '/user/webpush/subscribe',
    type: 'post',
    data: JSON.stringify(subscription),
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': authenticityToken(),
    },
    dataType: 'json',
    success: function (data) {
      console.info(data);
    }
  });
}

export function toggleFormSubmitButton(btn) {
  if(btn.prop('disabled')) {
    btn.html(btn[0].innerText)
    btn.removeClass('btn-warning');
    btn.addClass('btn-success');
    btn.prop('disabled', false);
  } else {
    btn.prop('disabled', true);
    btn.removeClass('btn-success');
    btn.addClass('btn-warning');
    btn.addClass()
    btn.prepend('<i class="fas fa-spinner fa-pulse"></i> ');
  }
}

function formHeaders() {
  return new Headers({
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token': authenticityToken(),
  });
}

function authenticityToken() {
  return document.querySelector('meta[name=csrf-token]').content;
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\\-/g, "+")
    .replace(/_/g, "/");
  return Buffer.from(base64, "base64");
}
